import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetContainerPricingAdminQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetContainerPricingAdminQuery = { __typename?: 'Query', getContainerPricingAdmin: { __typename?: 'AdminContainerPricing', store_default_container_prices_string: string, consumer_overdue_prices_string: string } };


export const GetContainerPricingAdminDocument = gql`
    query GetContainerPricingAdmin {
  getContainerPricingAdmin {
    store_default_container_prices_string
    consumer_overdue_prices_string
  }
}
    `;

/**
 * __useGetContainerPricingAdminQuery__
 *
 * To run a query within a React component, call `useGetContainerPricingAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainerPricingAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainerPricingAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContainerPricingAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetContainerPricingAdminQuery, GetContainerPricingAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainerPricingAdminQuery, GetContainerPricingAdminQueryVariables>(GetContainerPricingAdminDocument, options);
      }
export function useGetContainerPricingAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainerPricingAdminQuery, GetContainerPricingAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainerPricingAdminQuery, GetContainerPricingAdminQueryVariables>(GetContainerPricingAdminDocument, options);
        }
export type GetContainerPricingAdminQueryHookResult = ReturnType<typeof useGetContainerPricingAdminQuery>;
export type GetContainerPricingAdminLazyQueryHookResult = ReturnType<typeof useGetContainerPricingAdminLazyQuery>;
export type GetContainerPricingAdminQueryResult = Apollo.QueryResult<GetContainerPricingAdminQuery, GetContainerPricingAdminQueryVariables>;